import { Application, Controller } from "stimulus"

export default class QualityBarChartController extends Controller {

  static targets = ["canvas"]
  static values = { maxChartRating: { type: Number, default: 5 },
                    ratingScale: { type: Object, default: { defaultColor: "#484848",
                                                           topValues: { rating: 4.8, color: "#007a87" },
                                                           minValues: { rating: 4, color: "#ff5a5f" }
                                                         }
                                }
                  }

  plugin = {
    id: 'custom_canvas_background_color',
    beforeDraw: (chart) => {
      const ctx = chart.canvas.getContext('2d');
      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#EEEEEE';
      ctx.fillRect(5, 9, chart.width, 4);
      ctx.restore();
    }
  };

  connect() {
    this.canvasTargets.forEach((canvas) => {
      const ctx = canvas.getContext('2d');
      const config = this.chartConfig(ctx, this.plugin);
      new Chart(ctx, config);
    });
  }

  barColor(value){
    const ratingScale = this.ratingScaleValue;
    let ratingColor = ratingScale.defaultColor;
    if(value >= ratingScale.topValues.rating){ ratingColor = ratingScale.topValues.color };
    if(value <= ratingScale.minValues.rating){ ratingColor = ratingScale.minValues.color };
    return ratingColor;
  }

  chartConfig(ctx, plugin){
    const label = ctx.canvas.dataset.label;
    const value = ctx.canvas.dataset.value;
    return {
      type: 'bar',
      plugins: [plugin],
      data: {
        labels: [label],
        datasets: [
          {
            data: [Math.pow(value, 2)],
            backgroundColor: this.barColor(value),
            borderSkipped: false,
            barPercentage: 0.25,
            borderRadius: 8
          },
        ]
      },
      options: {
        indexAxis: 'y',
        maintainAspectRatio: false,
        responsive: true,
        elements: {
          bar: {
            borderWidth: 0,
            borderRadius: 4,
          }
        },
        scales: {
          x: {
            ticks: {
              display: false
            },
            grid: {
              display: false,
              drawBorder: false,
              drawOnChartArea: false,
            },
            min: 0,
            max: Math.pow(this.maxChartRatingValue, 2),
          },
          y: {
            ticks: {
              display: false
            },
            grid: {
              drawTicks: false,
              drawBorder: false,
              drawOnChartArea: false,
            }
          }
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          }
        }
      }
    }
  };

}

const application = Application.start()
application.register("quality-bar-chart", QualityBarChartController)